import { useRef, useEffect } from 'react';
import { isSameYear, isThisYear } from 'date-fns';
import { useCalendar } from '../../Context.js';
import { YearButton } from '../../styled.js';
import { isYearDisabled } from '../../utils/index.js';
import { jsx } from 'react/jsx-runtime';

function Year(props) {
  var ref = useRef(null);
  var date = props.date;
  var _useCalendar = useCalendar(),
    timeZone = _useCalendar.timeZone,
    locale = _useCalendar.locale,
    focusedDate = _useCalendar.focusedDate,
    selectYear = _useCalendar.selectYear,
    focusedYear = _useCalendar.focusedYear,
    min = _useCalendar.min,
    max = _useCalendar.max;
  var isSelected = isSameYear(date, focusedDate);
  var shouldFocus = isSameYear(date, focusedYear);
  var yearFormat = new window.Intl.DateTimeFormat(locale, {
    year: 'numeric',
    timeZone: timeZone
  });
  var disabled = isYearDisabled({
    date: date,
    min: min,
    max: max
  });
  var handleClick = function handleClick(event) {
    event.stopPropagation(); // If used inside ContextDropdown: Prevent it from closing
    selectYear(date);
  };
  useEffect(function () {
    if (ref.current && shouldFocus) {
      ref.current.focus();
      // Place the selected year in the center of the calendar instead of the bottom
      ref.current.scrollIntoView({
        block: 'center'
      });
    }
  }, [ref, shouldFocus]);
  return /*#__PURE__*/jsx(YearButton, {
    $isSelected: isSelected,
    onClick: handleClick,
    disabled: disabled,
    ref: ref,
    tabIndex: isSelected ? 0 : -1,
    $isThisYear: isThisYear(date),
    children: yearFormat.format(date)
  });
}

export { Year };
